'use client';

import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { useIntl } from 'react-intl';
import { selectedQuantity } from '../atoms';
import {
  QuantitySelectionUnmanaged,
  type QuantitySelectionProps,
} from '../QuantitySelection/QuantitySelection.client';

export type QuantitySelectionAtomizedProps = {
  quantitySelectionProps?: QuantitySelectionProps;
  hideLabel?: boolean;
};

export const QuantitySelectionAtomized = ({
  hideLabel = false,
  quantitySelectionProps,
}: QuantitySelectionAtomizedProps) => {
  const [atomQuantity, setAtomQuantity] = useAtom(selectedQuantity);
  const { formatMessage } = useIntl();

  // Quantity will be updated, if user uses miniDV
  useEffect(() => {
    if (quantitySelectionProps?.quantity) {
      setAtomQuantity(quantitySelectionProps.quantity);
    }
  }, [quantitySelectionProps?.quantity, setAtomQuantity]);

  return (
    <article>
      {!hideLabel && (
        <header className="text-size-body-sm mb-1 leading-2.5 font-normal select-none">
          {formatMessage({
            id: 'quantitySelection.label',
            defaultMessage: 'Anzahl',
          })}
        </header>
      )}
      <QuantitySelectionUnmanaged
        {...quantitySelectionProps}
        onUpdate={(value) => {
          setAtomQuantity(value);
        }}
        quantity={atomQuantity}
        max={quantitySelectionProps?.max}
      />
    </article>
  );
};
